import Box from '@mui/material/Box';
import ArrowIcon from '@mui/icons-material/ArrowRightAlt';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';

const ViewAllLink = ({ link }) => {
  if (!link?.link) return null;

  const linkObj = buildLinkObj(link);

  return (
    <Box
      component="a"
      display="flex"
      alignItems="center"
      title={linkObj.text || 'View All'}
      rel={getRel(linkObj)}
      href={linkObj.href}
      p={1}
    >
      <Box component="span" display={{ xs: 'none', sm: 'block' }} pr={1}>
        {linkObj.text || 'View All'}
      </Box>
      <ArrowIcon />
    </Box>
  );
};

export default ViewAllLink;
